<template>
    <div class="c-view">
        <InternalHeader>
            <playbook-create slot="actions">
                <Button slot="trigger" class="text-primary"
                    ><Icon :custom="'icon icon-add'" class="mr-3"></Icon> New
                    Playbook
                </Button>
            </playbook-create>
            <div slot="title" class="c-internal-header__title">Playbooks</div>
        </InternalHeader>
        <playbooks-filters
            class="mt-5"
            v-bind:user-id.sync="assignedToId"
            :users-enabled="true"
        ></playbooks-filters>
        <h3 class="mt-5">Active Playbooks</h3>
        <div class="mt-3">
            <p class="text-weight-bolder mt-5">Contacts</p>
            <playbooks-table
                class="mt-3"
                :rows="activeContacts"
                :loading="loading"
            ></playbooks-table>
            <p class="text-weight-bolder mt-5">Accounts</p>
            <playbooks-table
                class="mt-3"
                :rows="activeAccounts"
                :loading="loading"
            ></playbooks-table>
        </div>
        <h3 class="mt-5">Inactive Playbooks</h3>
        <div class="mt-3">
            <p class="text-weight-bolder mt-5">Contacts</p>
            <playbooks-table
                class="mt-3"
                :rows="inactiveContacts"
                :loading="loading"
            ></playbooks-table>
            <p class="text-weight-bolder mt-5">Accounts</p>
            <playbooks-table
                class="mt-3"
                :rows="inactiveAccounts"
                :loading="loading"
            ></playbooks-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        playbooksRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/playbooks"
                );
            },
        },
        playbooksStatisticsRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/playbooks-statistics"
                );
            },
        },
        usersRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/users"
                );
            },
        },
    },
    data() {
        return {
            playbooks: null,
            statistics: null,
            users: null,
            assignedToId: null,
            playbookLoading: false,
            statisticsLoading: false,
        };
    },
    components: {
        InternalHeader: function () {
            return import("@/js/components/partials/header");
        },
        PlaybookCreate: function () {
            return import("@/js/components/partials/playbook-create");
        },
        PlaybooksFilters: function () {
            return import("@/js/components/partials/playbooks-filters");
        },
        PlaybooksTable: function () {
            return import("@/js/components/partials/playbooks-table");
        },
    },
    created() {
        this.queryPlaybooks = _.debounce(this.queryPlaybooks, 1000, {
            leading: false,
            trailing: true,
        });
        this.queryStatistics = _.debounce(this.queryStatistics, 1000, {
            leading: false,
            trailing: true,
        });
        this.init();
    },
    watch: {
        assignedToId() {
            this.load();
        },
    },
    computed: {
        loading() {
            return this.playbooksLoading || this.statisticsLoading;
        },
        activeAccounts() {
            let _this = this;
            return _.chain(this.playbooks)
                .filter((playbook) => {
                    return (
                        playbook.status_id === 1 &&
                        playbook.entity_type_id === 1
                    );
                })
                .each((playbook) => {
                    playbook.statistics = _.find(_this.statistics, {
                        playbook_id: playbook.id,
                    });
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
        inactiveAccounts() {
            let _this = this;
            return _.chain(this.playbooks)
                .filter((playbook) => {
                    return (
                        playbook.status_id === 2 &&
                        playbook.entity_type_id === 1
                    );
                })
                .each((playbook) => {
                    playbook.statistics = _.find(_this.statistics, {
                        playbook_id: playbook.id,
                    });
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
        activeContacts() {
            let _this = this;
            return _.chain(this.playbooks)
                .filter((playbook) => {
                    return (
                        playbook.status_id === 1 &&
                        playbook.entity_type_id === 2
                    );
                })
                .each((playbook) => {
                    playbook.statistics = _.find(_this.statistics, {
                        playbook_id: playbook.id,
                    });
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
        inactiveContacts() {
            let _this = this;
            return _.chain(this.playbooks)
                .filter((playbook) => {
                    return (
                        playbook.status_id === 2 &&
                        playbook.entity_type_id === 2
                    );
                })
                .each((playbook) => {
                    playbook.statistics = _.find(_this.statistics, {
                        playbook_id: playbook.id,
                    });
                })
                .orderBy(["name"], ["asc"])
                .value();
        },
    },
    methods: {
        init() {
            this.queryUsers();
            this.load();
        },
        load() {
            this.playbookLoading = true;
            this.statisticsLoading = true;
            this.queryPlaybooks();
            this.queryStatistics();
        },
        async queryPlaybooks() {
            let page = 1;
            let finished = false;
            let request;
            let response;
            this.playbooks = [];
            while (!finished) {
                request = {
                    params: {
                        q: [],
                        sort_by: "name:asc",
                        page: page,
                        per_page: 50,
                        include: [],
                    },
                };
                response = await this.playbooksRepository.index(request);
                this.playbooks.push(...response.data.data);
                finished = _.get(response, "data.links.next") ? false : true;
                ++page;
            }
            this.playbookLoading = false;
        },
        async queryStatistics() {
            let page = 1;
            let finished = false;
            let request;
            let response;
            this.statistics = [];
            while (!finished) {
                request = {
                    params: {
                        q: [],
                        group_by: ["playbook_id"],
                        page: page,
                        per_page: 50,
                        include: [],
                        modifiers: [],
                    },
                };
                if (this.assignedToId) {
                    request.params.modifiers.push(
                        "owner[" + this.assignedToId + "]"
                    );
                }
                response = await this.playbooksStatisticsRepository.index(
                    request
                );
                this.statistics.push(...response.data.data);
                finished = _.get(response, "data.links.next") ? false : true;
                ++page;
            }
            this.statisticsLoading = false;
        },
        async queryUsers() {
            let page = 1;
            let finished = false;
            let request;
            let response;
            if (!this.users) {
                this.users = [];
            }
            while (!finished) {
                request = {
                    params: {
                        q: [],
                        sort_by: "name:asc",
                        page: page,
                        per_page: 50,
                        include: [],
                    },
                };
                response = await this.usersRepository.index(request);
                this.users.push(...response.data.data);
                finished = _.get(response, "data.links.next") ? false : true;
                ++page;
            }
        },
    },
};
</script>
